import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryId } from 'backend/dishes';
import MultipleSelect from './components/MultipleSelect';
import style from './SuggestedDishMultipleSelect.module.scss';

interface ISuggestedDishMultipleSelect {
	setFetchedSuggestedDishes: (value: IItemForGetShortInfo[]) => void;
	selectedSuggestedDishSubCategory: Nullable<string>;
	setSuggestedDishes: (value: string[]) => void;
	selectedSuggestedDishes: string[];
}

const SuggestedDishMultipleSelect: React.FC<ISuggestedDishMultipleSelect> = ({
	selectedSuggestedDishes,
	selectedSuggestedDishSubCategory,
	setSuggestedDishes,
	setFetchedSuggestedDishes,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
		selectedSuggestedDishSubCategory ? getDishesShortBySubCategoryId : null,
		selectedSuggestedDishSubCategory || '',
	);

	useEffect(() => {
		refetch();
	}, [selectedSuggestedDishSubCategory]);

	useEffect(() => {
		if (response) {
			setFetchedSuggestedDishes(response.data.dishes);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.dishes || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					selectedSuggestedDishes={selectedSuggestedDishes}
					selectedSuggestedDishSubCategory={selectedSuggestedDishSubCategory}
					setSuggestedDishes={setSuggestedDishes}
				/>
			</div>
		</div>
	);
};

export default React.memo(SuggestedDishMultipleSelect);
